import { render, staticRenderFns } from "./DataJson.vue?vue&type=template&id=c16bd430"
import script from "./DataJson.vue?vue&type=script&lang=js"
export * from "./DataJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports